import {useCallback} from "react"
import {passwordInputSymbols} from "./Interfaces"

export const usePasswordGenerator = () => {
    const generatePassword = useCallback((length = 14) => {
        const lowercase = "abcdefghijklmnopqrstuvwxyz"
        const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        const numbers = "0123456789"
        const symbols = passwordInputSymbols.join("")

        // Crypto-safe random index generator
        const getRandomIndex = (arrayLength: number) => {
            const randomArray = new Uint32Array(1)
            globalThis.crypto.getRandomValues(randomArray)
            return randomArray[0] % arrayLength
        }

        const getRandomChar = (chars: string) => chars[getRandomIndex(chars.length)]

        // Ensure at least one character from each category
        const password: string[] = [
            getRandomChar(lowercase),
            getRandomChar(uppercase),
            getRandomChar(numbers),
            getRandomChar(symbols),
        ]

        // Fill the remaining length with random characters from all sets
        const allChars = lowercase + uppercase + numbers + symbols
        while (password.length < length) {
            password.push(getRandomChar(allChars))
        }

        // Shuffle the array using Fisher-Yates algorithm
        for (let i = password.length - 1; i > 0; i--) {
            const j = getRandomIndex(i + 1)
            ;[password[i], password[j]] = [password[j], password[i]]
        }

        return password.join("")
    }, [])

    return {generatePassword}
}
